'use strict'; // Copyright 2015-2017 Parity Technologies (UK) Ltd.
// This file is part of Parity.

// Parity is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.

// Parity is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.

// You should have received a copy of the GNU General Public License
// along with Parity.  If not, see <http://www.gnu.org/licenses/>.
var _require =
require('js-sha3'),keccak_256 = _require.keccak_256; // eslint-disable-line camelcase

function isChecksumValid(_address) {
  var address = _address.replace('0x', '');
  var hash = keccak_256(address.toLowerCase());

  for (var n = 0; n < 40; n++) {
    var char = address[n];
    var isLower = char !== char.toUpperCase();
    var isUpper = char !== char.toLowerCase();
    var hashval = parseInt(hash[n], 16);

    if (hashval > 7 && isLower || hashval <= 7 && isUpper) {
      return false;
    }
  }

  return true;
}

function isAddress(address) {
  if (address && address.length === 42) {
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
      return false;
    } else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) {
      return true;
    }

    return isChecksumValid(address);
  }

  return false;
}

function toChecksumAddress(_address) {
  var address = (_address || '').toLowerCase();

  if (!isAddress(address)) {
    return '';
  }

  var hash = keccak_256(address.slice(-40));
  var result = '0x';

  for (var n = 0; n < 40; n++) {
    result = '' + result + (parseInt(hash[n], 16) > 7 ? address[n + 2].toUpperCase() : address[n + 2]);
  }

  return result;
}

module.exports = {
  isAddress: isAddress,
  isChecksumValid: isChecksumValid,
  toChecksumAddress: toChecksumAddress };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@parity/abi/lib/util/address.js
// module id = 112
// module chunks = 0